import BootstrapModal from "../../components/BootstrapModal";
import {Formik, Form, Field} from 'formik'
import TextField from "../../components/TextField";
import * as Yup from 'yup'
import PMSCheckBox from "../../components/PMSCheckBox";
import FormSelect from "../../components/FormSelect";
import {ProgressSpinner} from "primereact/progressspinner";

const AssestmentTitleIndicatorForm = ({modal, assestmentTitleIndicatorID, assestmentTitleID,indicatorSequenceNo,indicatorTitle,
indicatorTitleBangla,indicatorValue,active, isLoading,setactiveAssestmentTitleNames, onSubmit, onHide}) => {
    const validation = Yup.object({
        assestmentTitleID:  Yup.number().positive('please select assestment Title'),
        indicatorSequenceNo: Yup.string().required(),
        indicatorTitle: Yup.string().required(),
        //indicatorTitleBangla: Yup.string().required(),
		indicatorValue: Yup.number().positive('This field is Required'),
    })
    return (<>
        <BootstrapModal headerText="Add Title Indicator" size={40} visible={modal} onHide={onHide}>
            <Formik
                validationSchema={validation}
                initialValues={{
                    assestmentTitleIndicatorID: assestmentTitleIndicatorID, 
                    assestmentTitleID: assestmentTitleID,
				    indicatorSequenceNo: indicatorSequenceNo,
                    indicatorTitle: indicatorTitle,
				    indicatorTitleBangla: indicatorTitleBangla,
                    indicatorValue: indicatorValue, 
                    active: active}}
                onSubmit={onSubmit}>
                {formik =>
                    (<>
                        <Form>
                            <Field type="hidden" name="assestmentTitleIndicatorID"/>
                            <FormSelect id="assestmentTitleID" name="assestmentTitleID" options={setactiveAssestmentTitleNames}/>						
                            <TextField label={'Sequence No'} type="number" name="indicatorSequenceNo"/>
                            <TextField label={'Indicator Title'} type="text" name="indicatorTitle"/>							
                            <Field label={'Indicator Title(Bangla)'} type="hidden" value={'N/A'} name="indicatorTitleBangla"/>
                            <TextField label={'Indicator Value'} type="text" name="indicatorValue"/> 
                            <PMSCheckBox label={'Active'} name={'active'} id={'active'}/>
                            {isLoading ? <ProgressSpinner style={ {height:30,width:30} }/> : <button type="submit" className="btn btn-primary">{assestmentTitleIndicatorID === 0 ? 'Save' : 'Update'} </button>}

                        </Form>
                    </>)}

            </Formik>
        </BootstrapModal>
    </>)
}

export default AssestmentTitleIndicatorForm